// AUTO GENERATED FILE - Changes WILL be lost.
// vi - used as 'vi' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Phiếu cược",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Đặt cược",
  "betslip.clear": "Xóa tất cả",
  "betslip.clearResult": "Xóa",
  "betslip.noSelections": "Thêm lựa chọn cược để cược",
  "betslip.notLoggedIn": "Đăng nhập để bắt đầu cược",
  "betslip.refresh": "Làm mới",
  "betslip.totalStake": "Tổng tiền cược",
  "betslip.noHistoryData": "Không có thông tin đặt cược",
  "betslip.openBets": "Mở Cược",
  "betslip.betHistory": "Lịch Sử Cược",
  "betslip.betHistoryWon": "Thắng",
  "betslip.betHistoryLost": "Thua",
  "loading.loading": "Đang Tải",
  "loading.account": "Đang tải tài khoản",
  "loading.league": "Đang tải giải đấu",
  "loading.gameweeks": "Đang tải tuần thi đấu",
  "loading.markets": "Đang tải các kèo đấu",
  "loading.bethistory": "Đang Tải Lịch Sử Cược",
  "login.loginRequired": "Bạn cần đăng nhập",
  "login.loginToBet": "Vui lòng đăng nhập để bắt đầu cược",
  "navigation.back": "Trở lại",
  "navigation.close": "Đóng",
  "video.liveStreamAvailable": "Có Live-stream trực tiếp",
  "video.logInToWatch": "Vui lòng đăng nhập để xem",
  "error.error": "Lỗi",
  "error.404": "Không tìm thấy trang",
  "error.gameLaunchFailed": "Không thể mở trận đấu",
  "error.unknownErrorCode": "Lỗi không rõ: {code}",
  "error.minUnitStakeLimitExceeded": "Cược tối thiểu là {limit}",
  "error.maxUnitStakeLimitExceeded": "Cược tối đa là {limit}",
  "error.minTotalStakeLimitExceeded": "Tổng tiền cược tối thiểu là {limit}",
  "error.maxTotalStakeLimitExceeded": "Tổng tiền cược tối đa là {limit}",
  "error.notPlaced": "Không thể cược",
  "error.wagerDisallowed": "Cược không cho phép",
  "error.errorEventIsOff": "Sự kiện đã bắt đầu",
  "wagerType.Singles": "Đơn",
  "wagerType.Doubles": "Xiên 2",
  "wagerType.Trebles": "Xiên 3",
  "wagerType.Accumulator": "Tích lũy",
  "wagerType.Perm 4-Folds": "Xiên 4",
  "wagerType.Perm 5-Folds": "Xiên 5",
  "wagerType.Perm 6-Folds": "Xiên 6",
  "wagerType.Perm 7-Folds": "Xiên 7",
  "wagerType.Perm 8-Folds": "Xiên 8",
  "wagerType.Perm 9-Folds": "Xiên 9",
  "nomorebets": "Không thể cược thêm",
  "playtime": "Thời Gian Thi Đấu",
  "gameId": "ID Trận Đấu",
  "noGames": "Hiện không có trận đấu nào. Vui lòng kiểm tra lại sau.",
  "Home": "Đội nhà",
  "Away": "Đội khách",
  "Visitor": "Đội khách",
  "soccerbet.gameWeek": "TUẦN THI ĐẤU",
  "soccerbet.noGameWeeks": "Không có trận đấu nào. Hãy kiểm tra lại sau.",
  "soccerbet.league": "Bảng Xếp Hạng Giải Đấu",
  "soccerbet.table.name": "Tên",
  "soccerbet.table.won": "Thắng",
  "soccerbet.table.drawn": "Hòa",
  "soccerbet.table.lost": "Thua",
  "soccerbet.table.points": "Điểm",
  "abbr.event.Both Teams To Score": "Cả hai đội ghi bàn",
  "event.Both Teams To Score": "Cả hai đội đều ghi bàn",
  "event.Over / Under": "Tài/Xỉu",
  "event.Double Chance": "Cơ hội kép",
  "event.Match Result": "Kết Quả Trận Đấu",
  "event.Exact Goals": "Tỷ Số Chính Xác",
  "event.Correct Score": "Tỷ Số Chính Xác",
  "event.Match Result Both Score": "Kết quả cả hai đội ghi bàn",
  "event.Result Und/Over 1.5 Total Goals": "Kết Quả Tổng Bàn Thắng Tài/Xỉu 1.5",
  "event.Result Und/Over 2.5 Total Goals": "Kết Quả Tổng Bàn Thắng Tài/Xỉu 2.5",
  "event.Under Over 1.5 Total Goals": "Tổng Bàn Thắng Tài Xỉu 1.5",
  "event.Under Over 2.5 Total Goals": "Tổng Bàn Thắng Tài Xỉu 2.5",
  "event.Under Over 3.5 Total Goals": "Tổng Bàn Thắng Tài Xỉu 3.5",
  "event.Under Over 4.5 Total Goals": "Tổng Bàn Thắng Tài Xỉu 4.5",
  "event.Total Goals 1 To 2": "Tổng Số Bàn Thắng 1 tới 2",
  "event.Total Goals 1 To 3": "Tổng Số Bàn Thắng 1 tới 3",
  "event.Total Goals 1 To 4": "Tổng Số Bàn Thắng 1 tới 4",
  "event.Total Goals 2 To 3": "Tổng Số Bàn Thắng 2 tới 3",
  "event.Total Goals 2 To 4": "Tổng Số Bàn Thắng 2 tới 4",
  "event.Under Over 1.5 Home Goals": "Tài Xỉu 1.5 Đội Nhà Ghi Bàn",
  "event.Under Over 1.5 Away Goals": "Tài Xỉu 1.5 Đội Khách Ghi Bàn",
  "event.Home Team Exact Goals": "Tổng bàn thắng Đội Nhà",
  "event.Away Team Exact Goals": "Tổng bàn thắng Đội Khách",
  "selection.Yes": "Có",
  "selection.No": "Không",
  "selection.1+G": "1+Bàn Thắng",
  "selection.1+Ng": "1+Không Bàn Thắng",
  "selection.X+G": "X+Bàn Thắng",
  "selection.X+Ng": "X+Không Bàn Thắng",
  "selection.2+G": "2+Bàn Thắng",
  "selection.2+Ng": "2+Không Bàn Thắng",
  "selection.1+Yes": "1+Có",
  "selection.1+No": "1+Không",
  "selection.X+Yes": "X+Có",
  "selection.X+No": "X+Không",
  "selection.2+Yes": "2+Có",
  "selection.2+No": "2+Không",
  "selection.TID_ANY_GOAL_SCORED_YES": "Bàn Thắng",
  "selection.TID_ANY_GOAL_SCORED_NO": "Không Bàn Thắng",
  "selection.U": "Xỉu",
  "selection.O": "Tài",
  "selection.1+O": "1+Tài",
  "selection.X+O": "X+Tài",
  "selection.2+O": "2+Tài",
  "selection.1+U": "1+Xỉu",
  "selection.X+U": "X+Xỉu",
  "selection.2+U": "2+Xỉu",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1x",
  "selection.TID_DRAW_OR_AWAY_WIN": "x2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "sb-english.team.BRE": "Brentford"
}
